module.exports = __webpack_public_path__ + "img/testimg.a2519432.png";